import React, { useMemo } from "react";
import type { TravellerDetailsV2Props } from "./TravellerDetailsV2.types";
import { LoaderWrap, PageRoot, Spinner } from "./Styles";
import { unwrapTravellerPayload } from "./utils/unwrapPayload";
import { TravellerDetailsV2WithForm } from "./TravellerDetailsV2WithForm";

export const TravellerDetailsV2 = (props: TravellerDetailsV2Props) => {
  const { payload, loading = false, className, ...rest } = props;
  const data = useMemo(() => unwrapTravellerPayload(payload), [payload]);
  const components = data.components || [];
  const pageData = data.pageData;

  if (loading && !components.length) {
    return (
      <PageRoot className={className}>
        <LoaderWrap>
          <Spinner aria-label="Loading" />
        </LoaderWrap>
      </PageRoot>
    );
  }

  return (
    <TravellerDetailsV2WithForm
      components={components}
      pageData={pageData}
      loading={loading}
      className={className}
      {...rest}
    />
  );
};

export default TravellerDetailsV2;
